import { createPaginatedKey } from "api/keys";

export const commentsKeys = {
  comments: {
    comment: (id: string) => ["comments", id],
    list: createPaginatedKey("comments"),
  },
};
